// @flow

import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";
import {
  fontNormal,
  fontMedium,
  fontCondensedNormal
} from "../../_static/Typography";
import { buildText } from "../Text";

export const InfoContainer = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Description = styled(
  buildText({
    tag: "span",
    fontSize: 12,
    color: buildColor("grey", "900"),
    capitalize: true
  })
)`
  display: block;
  font-weight: bold;
  text-align: left;
  padding-bottom: 2px;
`;

export const OptionItem = styled(
  buildText({
    tag: "span",
    color: buildColor("grey", "800")
  })
)`
  font-size: 12px;
  position: relative;

  &:not(:last-child) {
    margin-right: 4px;
    padding-right: 5px;
  }
`;

export const InfoItems = styled.ul`
  font-family: ${fontNormal};
  font-size: 12px;
  line-height: 18px;
  white-space: normal;
  color: ${buildColor("grey", "800")};
`;

export const InfoItem = styled.li`
  display: inline;
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      font-family: ${fontMedium};
      font-weight: 500;
    `};
  ${({ hasChanges }) =>
    hasChanges &&
    css`
      color: ${buildColor("orange", "700")};
    `};
`;

export const Separator = styled(
  buildText({
    tag: "span",
    fontSize: 12,
    color: buildColor("grey", "600")
  })
)`
  font-family: ${fontNormal};
  font-weight: normal;
  line-height: 17px;
  vertical-align: initial;
`;

export const FavoriteTag = styled(
  buildText({
    tag: "span",
    color: buildColor("yellow", "900")
  })
)`
  margin-left: 2px;
  padding: 1px 6px;
  background: ${buildColor("yellow", "100")};
  border-radius: 12px;
  font-family: ${fontCondensedNormal};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  vertical-align: text-top;
`;

export const IconContainer = styled.div`
  display: inline-flex;
  margin-right: 4px;
  vertical-align: inherit;
`;
